import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";

class LinkListTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    render() {
        return (
            <div className="feature-details-linklist">
                <table className="linklist">
                    {this.renderLinks()}
                </table>
            </div>
        );
    }

    action(url) {
        window.location = url;
        /*const self = this;
        axios.get(url, {})
            .catch(function (error) {
                console.log('Download error', error);
            })
            .then(res => {
                console.log('Res', res);
                self.downloadFile('Some name.pdf', res);
            });*/
    }

    renderLink(link) {
        const url = FeatureUtils.prepareUrl(this.props.feature, link.url);
        const image = FeatureUtils.prepareUrl(this.props.feature, link.image);
        return (
            <tr key={link.name}>
                <td>
                    <a href={url} target="_blank">{link.name}</a>
                </td>
                <td>
                    <a href={url} target="_blank"><img src={image}/></a>
                </td>
            </tr>
        );
    }

    renderLinks() {
        return (
            <tbody>
            {this.props.tab.config.links.map(l => this.renderLink(l))}
            </tbody>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(LinkListTab);
